import { render, staticRenderFns } from "./Shipped.vue?vue&type=template&id=054ef846&scoped=true&"
import script from "./Shipped.vue?vue&type=script&lang=js&"
export * from "./Shipped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054ef846",
  null
  
)

export default component.exports